import { createTheme, ThemeProvider } from '@mui/material';
import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useReducer,
} from 'react';
import {
  ACTION_CLOSE_ALL_DRAWER,
  ACTION_CLOSE_LEFT_FLOATING_DRAWER,
  ACTION_CLOSE_MAIN_DRAWER,
  ACTION_CLOSE_RIGHT_FLOATING_DRAWER,
  ACTION_CLOSE_TOOLBAR,
  ACTION_DARK_MODE,
  ACTION_LEFT_DRAWER,
  ACTION_LEFT_DRAWER_JSX,
  ACTION_LEFT_DRAWER_NOT,
  ACTION_MAIN_APP_BAR,
  ACTION_MAIN_APP_BAR_NOT,
  ACTION_MAIN_BOTTOM_BAR,
  ACTION_MAIN_BOTTOM_BAR_NOT,
  ACTION_MAIN_DRAWER,
  ACTION_MAIN_DRAWER_NOT,
  ACTION_OPEN_LEFT_FLOATING_DRAWER,
  ACTION_OPEN_MAIN_DRAWER,
  ACTION_OPEN_RIGHT_FLOATING_DRAWER,
  ACTION_OPEN_TOOLBAR,
  ACTION_RESET,
  ACTION_RIGHT_DRAWER,
  ACTION_RIGHT_DRAWER_JSX,
  ACTION_RIGHT_DRAWER_NOT,
  ACTION_SET_APPBAR_JSX,
  ACTION_SET_TOOLBAR_JSX,
  PASS_JSX,
  ACTION_RESET_FLOATING_DRAWER,
  ACTION_MAIN_BOTTOM_BAR_JSX,
  ACTION_FORCE_SET_DARK_MODE,
  ACTION_OPEN_NOTIFICATION_DRAWER,
  ACTION_CLOSE_NOTIFICATION_DRAWER,
  ACTION_LIGHT_MODE,
  ACTION_FORCE_SET_LIGHT_MODE,
  RIGHT_DRAWER_WIDTH,
} from '../constants';
import Wrapper from './wrapper';
import { ConfirmProvider } from 'material-ui-confirm';
import { SnackbarProvider } from 'notistack';
import { useSelector } from 'react-redux';
import { ehrAPIService } from '../../../http-common';

const MainFrameStateContext = createContext();
const MainFrameDispatchContext = createContext();

export const useMainFrameState = () => {
  return useContext(MainFrameStateContext);
};

export const useMainFrameDispatch = () => {
  return useContext(MainFrameDispatchContext);
};

const initialState = {
  mainDrawerOpen: false,
  isMainDrawer: true,
  isAppBar: true,
  isBottomBar: true,
  isNotificationDrawer: true,
  isToolbarOpen: false,
  isLeftDrawerOpen: false,
  isRightDrawerOpen: false,
  isLeftDrawer: false,
  isRightDrawer: false,
  isNotificationDrawerOpen: false,
  isDark: localStorage.getItem('screenMode') === 'dark',
  jsx: <></>,
  toolBarJsx: null,
  appBarJsx: <></>,
  bottomBarJsx: <></>,
  LeftDrawerJsx: null,
  RightDrawerJsx: null,
  rightDrawerWidth: '',
};

const resetStateWithoutTheme = {
  mainDrawerOpen: false,
  isMainDrawer: true,
  isAppBar: true,
  isBottomBar: true,
  isNotificationDrawer: true,
  isToolbarOpen: false,
  isLeftDrawerOpen: false,
  isRightDrawerOpen: false,
  isLeftDrawer: false,
  isRightDrawer: false,
  isNotificationDrawerOpen: false,
  jsx: <></>,
  toolBarJsx: null,
  appBarJsx: <></>,
  bottomBarJsx: <></>,
  LeftDrawerJsx: null,
  RightDrawerJsx: null,
  rightDrawerWidth: '',
};

const mainFrameReducer = (state, action) => {
  switch (action.type) {
    case ACTION_MAIN_BOTTOM_BAR_JSX:
      return {
        ...state,
        bottomBarJsx: action?.payload,
      };
    case ACTION_CLOSE_ALL_DRAWER:
      return {
        ...state,
        isLeftDrawerOpen: false,
        isRightDrawerOpen: false,
        rightDrawerWidth: 0,
      };
    case ACTION_RESET_FLOATING_DRAWER:
      return {
        ...state,
        isLeftDrawerOpen: false,
        isRightDrawerOpen: false,
        LeftDrawerJsx: null,
        RightDrawerJsx: null,
        rightDrawerWidth: 0,
      };
    case ACTION_OPEN_MAIN_DRAWER:
      return {
        ...state,
        mainDrawerOpen: true,
      };
    case ACTION_CLOSE_MAIN_DRAWER:
      return {
        ...state,
        mainDrawerOpen: false,
      };

    case ACTION_OPEN_TOOLBAR:
      return {
        ...state,
        isToolbarOpen: true,
      };

    case ACTION_CLOSE_TOOLBAR:
      return {
        ...state,
        isToolbarOpen: false,
      };

    case ACTION_OPEN_NOTIFICATION_DRAWER: {
      return {
        ...state,
        isNotificationDrawerOpen: true,
      };
    }

    case ACTION_CLOSE_NOTIFICATION_DRAWER: {
      return {
        ...state,
        isNotificationDrawerOpen: false,
      };
    }
    case ACTION_OPEN_LEFT_FLOATING_DRAWER:
      return {
        ...state,
        isLeftDrawerOpen: true,
      };

    case ACTION_CLOSE_LEFT_FLOATING_DRAWER:
      return {
        ...state,
        isLeftDrawerOpen: false,
      };

    case ACTION_OPEN_RIGHT_FLOATING_DRAWER:
      return {
        ...state,
        isRightDrawerOpen: true,
      };

    case ACTION_CLOSE_RIGHT_FLOATING_DRAWER:
      return {
        ...state,
        isRightDrawerOpen: false,
        rightDrawerWidth: 0,
      };

    case ACTION_LEFT_DRAWER:
      return {
        ...state,
        isLeftDrawer: true,
      };

    case ACTION_LEFT_DRAWER_NOT:
      return {
        ...state,
        isLeftDrawer: false,
      };

    case ACTION_RESET:
      return {
        ...state,
        ...resetStateWithoutTheme,
      };

    case PASS_JSX:
      return {
        ...state,
        jsx: action.payload,
      };

    case ACTION_DARK_MODE:
      localStorage.setItem('screenMode', state.isDark ? 'light' : 'dark');
      return {
        ...state,
        isDark: !state.isDark,
      };

    case ACTION_FORCE_SET_LIGHT_MODE:
      localStorage.setItem('screenMode', 'light');
      return {
        ...state,
        isDark: false,
      };

    case ACTION_FORCE_SET_DARK_MODE: {
      localStorage.setItem('screenMode', 'dark');
      return {
        ...state,
        isDark: true,
      };
    }

    case ACTION_SET_TOOLBAR_JSX:
      return {
        ...state,
        toolBarJsx: action.payload,
      };
    case ACTION_SET_APPBAR_JSX:
      return {
        ...state,
        appBarJsx: action.payload,
      };

    case ACTION_LEFT_DRAWER_JSX:
      return {
        ...state,
        LeftDrawerJsx: action.payload,
      };

    case ACTION_RIGHT_DRAWER:
      return {
        ...state,
        isRightDrawer: true,
      };

    case ACTION_RIGHT_DRAWER_NOT:
      return {
        ...state,
        isRightDrawer: false,
        rightDrawerWidth: 0,
      };

    case ACTION_RIGHT_DRAWER_JSX:
      return {
        ...state,
        RightDrawerJsx: action.payload,
      };

    case ACTION_MAIN_APP_BAR:
      return {
        ...state,
        isAppBar: true,
      };

    case ACTION_MAIN_APP_BAR_NOT:
      return {
        ...state,
        isAppBar: false,
      };

    case ACTION_MAIN_DRAWER:
      return {
        ...state,
        isMainDrawer: true,
      };

    case ACTION_MAIN_DRAWER_NOT:
      return {
        ...state,
        isMainDrawer: false,
      };

    case ACTION_MAIN_BOTTOM_BAR:
      return {
        ...state,
        isBottomBar: true,
      };
    case ACTION_MAIN_BOTTOM_BAR_NOT:
      return {
        ...state,
        isBottomBar: false,
      };
    case RIGHT_DRAWER_WIDTH:
      return {
        ...state,
        rightDrawerWidth: action.payload,
      };

    default:
      return state;
  }
};

// eslint-disable-next-line import/no-anonymous-default-export
const Mainframe = props => {
  const [state, dispatch] = useReducer(mainFrameReducer, initialState);

  console.log(`reactContextState`, state);

  const currentTheme = useSelector(
    state => state?.current?.currentUserSettings?.display
  );

  useEffect(() => {
    if (currentTheme?.theme) {
      if (currentTheme?.theme === 'dark') {
        dispatch({ type: ACTION_FORCE_SET_DARK_MODE });
      } else {
        dispatch({ type: ACTION_FORCE_SET_LIGHT_MODE });
      }
    }
  }, [currentTheme]);

  const themeLight = useMemo(() => {
    return createTheme({
      palette: {
        mode: state.isDark ? 'dark' : 'light',

        ...(state?.isDark
          ? {
              drawerColor: '#2e3740',
              drawerIcon: '#fff',
              appBarColor: '#2e3740',
              appBarIcon: '#fff',
              toolBarColor: '#3A4750',
              toolBarIcon: '#fff',
              bottomBarColor: '#2e3740',
              bodyHeadingColor: '#00adb5',
              leftFloatingDrawerColor: '#3A4750',
              leftFloatingDrawerIcon: '#fff',
              rightFloatingDrawerColor: '#2e3740',
              rightFloatingDrawerIcon: '#fff',
              dividerColor: '#00adb5',
              textFieldColor: '#387CA3',
              background: {
                default: '#2e3740',
                paper: '#2e3740',
              },
              dataGridHeaderColor: '#00adb5',
              dashboardCard: {
                bg: '#2F3234',
              },
            }
          : {
              drawerColor: '#387CA3',
              drawerIcon: '#fff',
              appBarColor: '#fff',
              appBarIcon: '#275672',
              toolBarColor: '#fff',
              toolBarIcon: '#387CA3',
              bottomBarColor: '',
              bodyHeadingColor: '#275672',
              leftFloatingDrawerColor: '#fff',
              leftFloatingDrawerIcon: '#275672',
              rightFloatingDrawerColor: '#fff',
              rightFloatingDrawerIcon: '#275672',
              dividerColor: '#77CED2',
              textFieldColor: '#387CA3',
              primary: {
                main: '#387CA3',
              },
              dataGridHeaderColor: '#f8f8f8',
              dashboardCard: {
                bg: '#EBF6F9',
              },
            }),
      },

      zIndex: {},
    });
  }, [state.isDark]);

  return (
    <>
      <SnackbarProvider
        style={{
          backgroundColor: state?.isDark ? '#181D1F' : 'white',
          color: state?.isDark ? 'white' : '#2096F3',
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        maxSnack={3}
      >
        <MainFrameStateContext.Provider value={state}>
          <MainFrameDispatchContext.Provider value={dispatch}>
            <ThemeProvider theme={themeLight}>
              <ConfirmProvider>
                <Wrapper
                  firebaseUser={props?.firebaseUser}
                  isOnline={props?.isOnline}
                >
                  {props.children}
                </Wrapper>
              </ConfirmProvider>
            </ThemeProvider>
          </MainFrameDispatchContext.Provider>
        </MainFrameStateContext.Provider>
      </SnackbarProvider>
    </>
  );
};

export default Mainframe;
